import { useMutation, useQueryClient } from "react-query";
import { fetchData } from "../api/client";

export const useRequests = () => {
  const queryClient = useQueryClient();

  const updateMutation = useMutation(
    (request) => {
      const method = request.id ? "PUT" : "POST";
      const endpoint = request.id ? `/requests/${request.id}` : `/requests`;
      return fetchData(endpoint, method, request);
    },
    {
      onSuccess: (_data, variables) => {
        const id = variables?.id;

        // Atualiza os detalhes da conversa atual (usa o mesmo padrão de chave do hook useConversationDetails)
        if (id != null) {
          queryClient.invalidateQueries(["conversationDetails", id]);
        } else {
          queryClient.invalidateQueries({ queryKey: ["conversationDetails"] });
        }

        // Atualiza a lista de conversas (ex.: chip de usuário/agente / status)
        queryClient.invalidateQueries({ queryKey: ["conversations"] });
      },
    }
  );

  return { updateMutation };
};
